import WebFont from 'webfontloader'

WebFont.load({
  google: {
    families: ['Cairo:400,700', 'sans-serif']
  }
})
export const EnglishFont = 'Cairo'
export const ArabicFont = 'Cairo'
